import { RapidStorLocation } from "../../services/rapidstor";

const defaultLocations: RapidStorLocation[] = [
  {
    SiteID: 49410,
    OwnerID: "10",
    LanguageID: "1",
    sLocationCode: "YORK",
    sGlobalSiteNum: "49410",
    iMobileType: "0",
    iRegionalOptions: 2,
    iOnLineChargeType: "0",
    iGMTTimeOffset: 0,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sContactName: "Anthony Brown",
    sEmailAddress: "york@surestore.co.uk",
    sSiteName: "SureStore, York",
    sSiteAddr1: "Auster Rd",
    sSiteAddr2: null,
    sSiteCity: "York",
    sSiteRegion: "Yorkshire",
    sSitePostalCode: "YO30 4GD",
    sSiteCountry: "United Kingdom",
    sSitePhone: "01904 942090",
    sSiteFAX: "0",
    iFeatMaxUnits: "500",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2023-08-22T20:01:55.7-04:00",
    bZipCodeData_Use: "false",
    dcLongitude: "-1.0919190000",
    dcLatitude: "53.9887810000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "false",
    iIdentifier: "0",
    bUseInclusiveTaxation: false,
    iBusinessType: "0",
    iSiteDataType: "0",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2023-02-17T07:58:57.373-05:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2023-08-23T00:01:55.700Z",
    uTS: "AAAAAAU/s/8=",
    DivisionID: "10",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: null,
    iSubscriptionType: "0",
    bForcePushRates: "0",
    iWebRatesType: "0",
    tWeekdayStrt: "00:00:00",
    tWeekdayEnd: "23:59:59",
    tSaturdayStrt: "00:00:00",
    tSaturdayEnd: "23:59:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    rapidstorEnabled: true,
    administrative: {
      availableForUse: false,
      boxshopEnabled: true,
      carouselListing: false,
      insuranceEnabled: false,
      merchEnabled: false,
      refreshEnabled: false,
      rslite: false,
      rsliteKey: "N/A",
      testMode: false,
      useMtasForAuth: false,
    },
    fees: {
      adminFee: 20,
      cleaningFee: 50,
      lateDays: 3,
      lateFee: 20,
      moveOutNotice: 2,
      nsfFee: 20,
      securityDeposit: 100,
    },
    friendlyName: null,
    hours: {
      gateClose: "5:00pm",
      gateCloseSaturday: "5:00pm",
      gateCloseSunday: "5:00pm",
      gateOpen: "9:00am",
      gateOpenSaturday: "9:00am",
      gateOpenSunday: "9:00am",
      officeFridayClose: "5:00pm",
      officeFridayOpen: "9:00am",
      officeMondayClose: "5:00pm",
      officeMondayOpen: "9:00am",
      officeSaturdayClose: "5:00pm",
      officeSaturdayOpen: "9:00am",
      officeSundayClose: "5:00pm",
      officeSundayOpen: "9:00am",
      officeThursdayClose: "5:00pm",
      officeThursdayOpen: "9:00am",
      officeTuesdayClose: "5:00pm",
      officeTuesdayOpen: "9:00am",
      officeWednesdayClose: "5:00pm",
      officeWednesdayOpen: "9:00am",
    },
    pdfFonts: {
      lease: "Arial",
      insuranceDocs: "Arial",
      receipt: "Arial",
    },
    rapidstor: {
      allowedCreditCardTypes: {
        amex: true,
        mastercard: true,
        visa: true,
      },
      allowMoveIn: true,
      allowOriginUrl: [],
      allowReservation: true,
      allowReservationsWhenNoAvailability: false,
      areaSizeSymbol: "m²",
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      attachLeaseToMoveInConfirmationEmail: true,
      attachReceiptToMoveInConfirmationEmail: true,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      autoBillCheckedByDefault: false,
      autoESignRedirect: false,
      autoOptInSMS: false,
      billingDefault: "MonthlyAnniversary",
      bookOnlineDiscount: 0,
      boxshopCategoryAlphaOrder: false,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      boxshopTermsConditions: "",
      checkForExistingTenant: false,
      completeMoveinURL: "",
      country: "AU",
      currency: "AUD",
      currencySymbol: "$",
      dateFormat: "yyyy-MM-dd",
      datesClosed: "",
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      directDebit: {
        enabled: false,
        creditAmount: 0,
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: null,
          hours: null,
          mintues: null,
        },
        quoteEmail: {
          "1": {
            subject: null,
          },
          "2": {
            days: null,
            hours: null,
            minutes: null,
            subject: null,
          },
          "3": {
            days: null,
            hours: null,
            minutes: null,
            subject: null,
          },
        },
      },
      enquiryAPI: {
        numOptions: 3,
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      eSignReturnUrl: "",
      facilitySelfService: {
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
      },
      features: {
        boxshop: "standard",
        "carousel-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "movein-wizard": "single-page",
        "reservation-with-fee-wizard": "standard",
        "tenant-accounts": "standard",
        "tiered-unit-listing": "standard",
        "unit-listing": "standard",
      },
      forceTaxInclusive: false,
      freeShippingDealAmount: 150,
      freeShippingDealEnabled: false,
      groundFloor: 0,
      hideBoxshop: false,
      hideDateOfBirth: true,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hidePostalCode: false,
      hidePrices: false,
      hideQuickSearch: false,
      hideState: false,
      hideUnitsMinAvailable: false,
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceCustomFormat: "",
      insuranceEsignReturnUrl: "",
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceRequired: false,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      language: {
        selectionOption: "auto-detect",
      },
      legacyPickupLocations: null,
      legacyPickupLocationsEnabled: false,
      locationPageUrl: "",
      marketingSurvey: {
        questions: {
          customerType: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
        use: true,
      },
      mediumLargeSize: 9,
      minAvailableUnits: 0,
      moveinEmailSubject: "",
      moveinHideACP: false,
      moveinNumberOfDaysInAdvanceLimit: 7,
      moveinRedirectUrl: "",
      noAvailableUnitsText: "Call for Availability",
      notificationsAdditionalBCCAddresses: [],
      notificationsAdditionalCCAddresses: [],
      notificationsFromAddress: "",
      notificationsFromName: "",
      notificationsReplyAddress: "",
      payLaterButtonText: "Pay Later",
      paymentGateways: {
        bypassSitelinkProcessing: false,
        gatewayToUse: "",
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          paygateId: "",
          payMethod: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["bn", "cc", "dp", "gc", "pp"],
          secure3d: "try3d",
        },
        paypal: {
          clientId: "",
          clientSecret: "",
          currency: "",
        },
        paytabs: {
          countryCode: "",
          merchantEmail: "",
          merchantId: "",
          merchantSiteUrl: "",
          messageLanguage: "",
          secretKey: "",
        },
        use: false,
      },
      payNowButtonText: "Pay Now",
      pickupEnabled: true,
      pushRate: false,
      quickReserveButtonText: "Quick Reserve",
      recaptcha: {
        enabled: false,
        secretKey: "",
        siteKey: "",
        tolerance: 0.5,
      },
      requireAutobill: false,
      reservationEmailSubject: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            days: 30,
            from: 0,
            to: 100,
          },
        ],
        enabled: false,
      },
      reservationExpireReservationDays: 30,
      reservationNumberOfDaysInAdvanceChargeFee: 365,
      reservationNumberOfDaysInAdvanceLimit: 30,
      reservationPopupText: "",
      resetPasswordUrl: "",
      scheduleFollowUpEmails: false,
      shippingEnabled: false,
      shippingInventoryItem: null,
      showAreaInsteadOfDimensions: false,
      showAutobillTerms: false,
      showMoveInDateLimitMessage: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showVehicleQuickSearch: false,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      siteLinkLeaseFields: [],
      siteLogo: "https://ik.imagekit.io/bytcx9plm/sitelogo.png",
      siteOpeningDate: null,
      sizeSymbol: "m",
      smallMediumSize: 3,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
        invoiceHistory: {
          enabled: true,
        },
        notification: {
          enabled: false,
          content: null,
          ctaButton: {
            text: null,
          },
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
      },
      tieredPricing: {
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        noAvailableUnitsText: "Call for Availability",
        showAvailableUnitsCount: false,
        showPricesShowNeeded: true,
        showTiersWithNoAvailableUnits: true,
        showVehicleQuickSearch: false,
      },
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: false,
      },
      useAutoBilling: true,
      useBoxShopCoupons: false,
      useDealCoupons: false,
      useDescriptorTitle: false,
      useESign: false,
      useESignForInsuranceDocs: false,
      useWebRates: false,
      webhooks: {
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      wizards: {
        moveinSingle: {
          allowIdUpload: false,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          hideAlternativeContact: true,
          hideBoxshop: false,
          hideDateOfBirth: true,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideInsurance: false,
          hideInsurancePicker: false,
          hidePostalCode: false,
          hideState: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntry: false,
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
          insuranceRequired: false,
          requireAlternativeContactPhoneNumberField: true,
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: false,
      completeMoveinUrl: "",
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
    },
    skin: {
      accentColours: {},
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      highlightColour: "#ffffff",
      mainColour: "#f09a05",
      moveinTimeRemaining: false,
    },
    token:
      "42e449ced7a9b9f9cb0e980055b83c8b1871a7f8a47de97f1764df1f452dfb49b4f94c7b215c807e28fa7efe96f23593",
    collections: {
      form: {
        name: "form",
        job: "CSBT/YORK/form",
        status: "finished",
        timestamp: 1692759026800,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CSBT/YORK/discountPlan",
        status: "finished",
        timestamp: 1692763557424,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "TRIGGERED: CSBT/YORK/unitTypeGroup",
        status: "finished",
        timestamp: 1692801963433,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CSBT/YORK/paymentSettings",
        status: "finished",
        timestamp: 1692665954302,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CSBT/YORK/chargeDescription",
        status: "finished",
        timestamp: 1692665954299,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CSBT/YORK/unitsFull",
        status: "finished",
        timestamp: 1692665954299,
      },
      site: {
        name: "site",
        job: "CSBT/YORK/site",
        status: "finished",
        timestamp: 1692665954299,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CSBT/YORK/marketingSource",
        status: "finished",
        timestamp: 1692665954302,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CSBT/YORK/insuranceCoverage",
        status: "finished",
        timestamp: 1692665954302,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CSBT/YORK/paymentTypes",
        status: "finished",
        timestamp: 1692665954302,
      },
      inventory: {
        name: "inventory",
        job: "CSBT/YORK/inventory",
        status: "finished",
        timestamp: 1692665954299,
      },
    },
    changeToken:
      "27af9f78bf667062a64badb4126a474d79bcb616c6d210356552eec7bfefeb42f0f10c7f082f838957230080c7332aaf",
    changedAt: "2023-08-23T13:31:43.906Z",
    deleted: false,
    originalName: "SureStore, York",
    scaConfiguration: {
      CurrencyCode: "826",
      FirstApiEnabled: true,
      HostedPaymentsUrl: "https://www.ipg-online.com/connect/gateway/processing",
      StoreId: "1111407066",
    },
    dSaturdayEnd: "2023-03-03T23:59:59-05:00",
    dSaturdayStrt: "2023-03-03T00:00:00-05:00",
    dSundayEnd: "2023-03-03T23:59:59-05:00",
    dSundayStrt: "2023-03-03T00:00:00-05:00",
    dWeekdayEnd: "2023-03-03T23:59:59-05:00",
    dWeekdayStrt: "2023-03-03T00:00:00-05:00",
    sLegalName: "IPIF Storage Ltd",
    sLocationDesc: null,
    sTaxNumber: "370 482 693",
    sWebSiteURL: null,
  },
];
export default defaultLocations;
